import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Breadcrumb } from "semantic-ui-react";
import LinkWithReset from "../utils/LinkWithReset";

class Breadcrumbs extends PureComponent {
  static propTypes = {
    sections: PropTypes.array.isRequired
  };

  parseSections = () => {
    const { sections } = this.props;

    if (!sections || sections.length < 1) return undefined;

    return sections.map((item, index) => {
      return (
        <Breadcrumb.Section
          key={item.key || `crumb-${index}`}
          content={item.content}
          active={item.active}
          to={item.href}
          as={item.href ? LinkWithReset : "div"}
        />
      );
    });
  };

  render() {
    return <Breadcrumb icon="right angle" sections={this.parseSections()} />;
  }
}
export default Breadcrumbs;
